import React from "react";
import { Navigate } from "react-router-dom";

const Authmiddleware = (props) => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));

  if (!authUser) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  // Extract user role
  const userRole = (authUser && authUser.user && authUser.user.roles && authUser.user.roles.length > 0)
    ? authUser.user.roles[0].slug
    : "company-admin"; // Fallback

  const { roles } = props;

  // Check if role is allowed
  if (roles && !roles.includes("*") && !roles.includes(userRole)) {
    return <Navigate to="/pages-404" />;
  }

  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
